import {
  SummaryMetricGrid,
  type SummaryMetric,
} from "@/components/ui/SummaryGrid";
import type { ReactNode } from "react";

export type HomeSelectionQuickMetric = SummaryMetric;

type HomeSelectionQuickDetailsProps = {
  icon: ReactNode;
  eyebrow: string;
  title: string;
  subtitle: string;
  badge?: ReactNode;
  metrics: HomeSelectionQuickMetric[];
};

export function HomeSelectionQuickDetails({
  icon,
  eyebrow,
  title,
  subtitle,
  badge,
  metrics,
}: HomeSelectionQuickDetailsProps) {
  return (
    <div className="border-t border-softiq-primary/10 dark:border-white/10">
      <div className="flex flex-col gap-4 px-5 py-5 sm:flex-row sm:items-center sm:px-6">
        <span className="flex size-11 shrink-0 items-center justify-center rounded-xl bg-softiq-secondary-shade-200 text-softiq-primary dark:bg-white/10 dark:text-softiq-secondary">
          {icon}
        </span>
        <div className="min-w-0 flex-1">
          <p className="app-section-label">{eyebrow}</p>
          <div className="mt-1 flex flex-wrap items-center gap-2">
            <h2 className="truncate text-base font-medium tracking-[-0.02em]">
              {title}
            </h2>
            {badge}
          </div>
          <p className="app-section-description mt-1 truncate">{subtitle}</p>
        </div>
      </div>

      <SummaryMetricGrid metrics={metrics} />
    </div>
  );
}
